<div class="container-fluid">
  <div class="row" *ngIf="isLoading">
    <div class="col-lg-6" style="padding: 50px">
      <mat-progress-spinner style="margin: auto" [diameter]="150" [strokeWidth]="10"
                            mode="indeterminate"></mat-progress-spinner>
    </div>
  </div>
  <div class="row" *ngIf="!isLoading">
    <div class="col-sm-12" style="max-width: 800px">
      <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
        <mat-card appearance="outlined">
          <mat-card-title>
            Phone Number <span class="phone-number-title">{{ editModel.number | phoneNumber }}</span>
          </mat-card-title>
          <mat-card-content>
            @if (serverError) {
              <div style="margin-bottom: 5px">
                <p-message severity="error" icon="pi pi-exclamation-triangle">
                  {{ serverErrorMessage ?? 'Error occurred' }}
                </p-message>
              </div>
            }

            <app-mat-text-input [formControl]="customerDidAliasControl" label="Phone Number Alias Name"
                                name="customerDidAlias"
                                [submitted]="submitted"
                                explanation="Enter your preferred phone number name for faster lookup in phone numbers list."
                                [infoText]="'You can enter up to 100 characters (including spaces)'"
            ></app-mat-text-input>

            <app-mat-text-input [formControl]="cnamControl" label="Caller ID" name="cnam"
                                [submitted]="submitted"
                                [disabled]="!editModel.allowEditCnam"
                                explanation="Enter your preferred Company Caller ID Name exactly the way you want it to appear on Caller ID displays, for local calls made from your local TeleGo phone numbers. Caller ID should be active within 7 to 14 business days. If the accurate Caller ID isn't showing 14 days after the request was submitted, contact support@telego.net for assistance."
                                [infoText]="editModel.allowEditCnam ? 'You can enter up to 15 characters (including spaces)' : 'This feature isn\'t available for this number'"
            ></app-mat-text-input>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined"
                  *ngIf="editModel.allowSMS || editModel.allowWaba">
          <mat-card-title>Messaging Settings</mat-card-title>
          <mat-card-content>
            @if (serverError) {
              <div style="margin-bottom: 5px">
                <p-message severity="error" icon="pi pi-exclamation-triangle">
                  {{ serverErrorMessage ?? 'Error occurred' }}
                </p-message>
              </div>
            }
            @if (campaignLimitExceeded) {
              <div style="margin-bottom: 5px">
                <p-message severity="error" icon="pi pi-exclamation-triangle">
                  <span>
                    You have enabled the maximum allowed phone numbers for SMS on your account. Please contact us
                    <a class="btn-link" target="_blank" href="mailto://support@telego.net">support&#64;telego.net</a>
                    or
                    <a class="btn-link" role="button" (click)="openSupportWidget()">fill form here</a> if you need to add more SMS numbers.
                  </span>
                </p-message>
              </div>
            }
            @if (!editModel.campaignNumber) {
              <div style="margin-bottom: 5px">
                <p-message severity="warn" icon="pi pi-exclamation-triangle">
                  <span>
                    This phone number is not 10DLC registered and may be blocked from sending messages.
                    <a class="btn-link" role="button" (click)="openSupportWidget()">Please contact us</a> to register this number.
                  </span>
                </p-message>
              </div>
            }
            <mat-form-field class="regular-form-field" appearance="outline" *ngIf="editModel.allowSMS">
              <mat-label>Enable Messaging</mat-label>
              <mat-select [formControl]="smsOptionControl" (valueChange)="onMessagingTypeChanged($event)">
                <mat-option value="basic" [disabled]="!hasBasicMessaging">Basic Messaging</mat-option>
                <mat-option value="pro" [disabled]="!hasProMessaging">Pro Messaging</mat-option>
                <!--<mat-option value="broadcasting" [disabled]="!hasProMessaging">Broadcasting</mat-option>-->
                <mat-option value="disabled">Disabled</mat-option>
              </mat-select>
            </mat-form-field>

            <div *ngIf="smsMessagingType !== 'disabled' || editModel.allowWaba">
              <app-mat-checkbox-input [formControl]="smsMarkAllAsReadControl"
                                      *ngIf="(smsMessagingType !== 'disabled' && smsMessagingType !== 'basic') || editModel.allowWaba"
                                      label="Mark message as read for all users"
                                      explanation="For numbers used with more than one user: If one person views a new message, mark that message as read for all users"
                                      name="smsMarkAllAsRead"></app-mat-checkbox-input>

              <div class="form-group">
                <table class="phone-form-input" style="width: 100%">
                  <colgroup>
                    <col style="width: 220px">
                    <col>
                    <col>
                    <col>
                  </colgroup>
                  <thead>
                  <tr>
                    <th><label>Assign to</label></th>
                    <th colspan="3">
                      <label style="width: 100%;">
                        Would you like to be notified of unread SMS messages when not logged in?
                        <!--<mat-icon class="explanation"
                                  matTooltip="This user will receive emails to notify them of any new, unread SMS messages in their TeleGo Customer Portal. These emails will be sent if this user is not logged in, and if the message remains unread for 10 minutes.">
                          info_outline
                        </mat-icon>-->
                      </label>
                    </th>
                    <!--<th>
                      <label style="text-align: center;width: 100%;">
                        Receive New Messages in Email
                        <mat-icon class="explanation"
                                  matTooltip="This user will receive email notifications containing the actual text content of a new and unread SMS message. These emails will be sent if the user is not logged in, and if the message remains unread for 10 minutes.">
                          info_outline
                        </mat-icon>
                      </label>
                    </th>-->
                    <th>&nbsp;</th>
                  </tr>
                  </thead>
                  <tbody formArrayName="messagingUsers">
                  <tr *ngFor="let user of messagingUsers.controls; let i=index" [formGroupName]="i"
                      style="vertical-align: top;">
                    <td>
                      <app-mat-simple-select [formControl]="getFormControl('customerUserId', user)"
                                             [hideLabel]="true"
                                             [inlineLabel]="true"
                                             [submitted]="submitted"
                                             [selectItems]="customerUsers"
                                             [hideRequiredMarker]="true"
                                             name="customerUserId">
                      </app-mat-simple-select>
                    </td>
                    <td class="center-cell">
                      <app-mat-checkbox-input [formControl]="getFormControl('receiveEmail', user)" name="receiveEmail"
                                              [submitted]="submitted"
                                              label="Receive email alerts"
                                              explanation="This user will receive emails to notify them of any new, unread SMS messages in their TeleGo Customer Portal. These emails will be sent if this user is not logged in, and if the message remains unread for 10 minutes."
                                              (ngModelChange)="onEmailOptionsChanged($event, 'receiveEmail', user)"></app-mat-checkbox-input>
                    </td>
                    <td class="center-cell">
                      <app-mat-checkbox-input [formControl]="getFormControl('includeText', user)" name="includeText"
                                              [submitted]="submitted"
                                              label="View new messages in email"
                                              explanation="This user will receive email notifications containing the actual text content of a new and unread SMS message. These emails will be sent if the user is not logged in, and if the message remains unread for 10 minutes."
                                              (ngModelChange)="onEmailOptionsChanged($event, 'includeText', user)"></app-mat-checkbox-input>
                    </td>
                    <td>
                      <button mat-icon-button color="warn" (click)="removeMessagingUser(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div fxLayout="row" fxLayoutGap="5px">
                  @if (smsMessagingType === 'broadcasting' || smsMessagingType === 'pro' || (smsMessagingType !== 'pro' && messagingUsers.controls.length < 1) || editModel.allowWaba) {
                    <button type="button" mat-stroked-button (click)="addMessagingUser()">
                      <i class="material-icons">add</i> Add User
                    </button>
                  }
                  @if (smsMessagingType === 'broadcasting' || smsMessagingType === 'pro' || editModel.allowWaba) {
                    <button type="button" mat-stroked-button (click)="addAllMessagingUsers()">
                      <i class="material-icons">add</i> Add All Users
                    </button>
                  }
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" *ngIf="editModel.allowFax">
          <mat-card-title>Fax Settings</mat-card-title>
          <mat-card-content>
            <div class="form-group">
              <label>Fax From Name</label>
              <p>{{ editModel.faxSettings.displayName || 'unknown' }}</p>
            </div>

            <div class="form-group">
              <table class="phone-form-input" style="width: 100%">
                <colgroup>
                  <col style="width: 220px">
                  <col>
                </colgroup>
                <thead>
                <tr>
                  <th><label>Assign to</label></th>
                  <th>
                    <label style="text-align: center;width: 100%;">
                      Receive
                      <mat-icon class="explanation"
                                matTooltip="This user is authorized to receive incoming faxes to this number within the TeleGo Customer Portal.">
                        info_outline
                      </mat-icon>
                    </label>
                  </th>
                  <th>
                    <label style="text-align: center;width: 100%;">
                      Send
                      <mat-icon class="explanation"
                                matTooltip="This user is authorized to send incoming faxes from this number within the TeleGo Customer Portal.">
                        info_outline
                      </mat-icon>
                    </label>
                  </th>
                  <th>
                    <label style="text-align: center;width: 100%;">
                      View All<br>Sent Faxes
                      <mat-icon class="explanation"
                                matTooltip="This user can view all sent faxes for this number within the TeleGo Customer Portal.">
                        info_outline
                      </mat-icon>
                    </label>
                  </th>
                  <th>
                    <label style="text-align: center;width: 100%;">
                      Receive Email<br>Notifications
                      <mat-icon class="explanation"
                                matTooltip="This user will receive emails to notify them of any new, unread faxes sent to this number in their TeleGo Customer Portal. These emails will be sent even if the user is logged in.">
                        info_outline
                      </mat-icon>
                    </label>
                  </th>
                  <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody formArrayName="faxUsers">
                <tr *ngFor="let user of faxUsers.controls; let i=index" [formGroupName]="i"
                    style="vertical-align: top;">
                  <td>
                    <app-mat-simple-select [formControl]="getFormControl('customerUserId', user)"
                                           [hideLabel]="true"
                                           [inlineLabel]="true"
                                           [submitted]="submitted"
                                           [selectItems]="customerFaxUsers"
                                           [hideRequiredMarker]="true"
                                           name="customerUserId">
                    </app-mat-simple-select>
                  </td>
                  <td class="center-cell">
                    <app-mat-checkbox-input [formControl]="getFormControl('allowReceive', user)" name="allowReceive"
                                            [submitted]="submitted"></app-mat-checkbox-input>
                  </td>
                  <td class="center-cell">
                    <app-mat-checkbox-input [formControl]="getFormControl('allowSend', user)" name="allowSend"
                                            [submitted]="submitted"></app-mat-checkbox-input>
                  </td>
                  <td class="center-cell">
                    <app-mat-checkbox-input [formControl]="getFormControl('viewAllSend', user)" name="viewAllSend"
                                            [submitted]="submitted"></app-mat-checkbox-input>
                  </td>
                  <td class="center-cell">
                    <app-mat-checkbox-input [formControl]="getFormControl('receiveEmail', user)" name="receiveEmail"
                                            [submitted]="submitted"></app-mat-checkbox-input>
                  </td>
                  <td>
                    <button mat-icon-button color="warn" (click)="removeFaxUser(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <div fxLayout="row" fxLayoutGap="5px">
                <button type="button" mat-stroked-button (click)="addFaxUser()"><i
                  class="material-icons">add</i> Add User
                </button>
                <button type="button" mat-stroked-button (click)="addAllFaxUsers()"><i class="material-icons">add</i>
                  Add All Users
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" *ngIf="editModel.allowFax">
          <mat-card-title>Email to Fax Settings</mat-card-title>
          <mat-card-content>
            <div class="phone-form-input">
              <app-email-list-input [formInGroup]="form"
                                    [formFieldName]="'allEmailGroups'"
                                    [formInControl]="getFormControlArray('allEmailGroups')"
                                    label="Fax Allowed Emails"
                                    addLabel="Add Email"
                                    [submitted]="submitted"
              ></app-email-list-input>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" *ngIf="editModel.allowFax">
          <mat-card-title>Fax Domains</mat-card-title>
          <mat-card-content>
            <div class="form-group">
              <table class="phone-form-input" style="width: 100%">
                <colgroup>
                  <col style="width: 220px">
                  <col>
                </colgroup>
                <thead>
                <tr>
                  <th><label>Domain</label></th>
                  <th>
                    <label style="text-align: center;width: 100%;">
                      Receive
                      <mat-icon class="explanation"
                                matTooltip="This user is authorized to receive incoming faxes to this number within the TeleGo Customer Portal.">
                        info_outline
                      </mat-icon>
                    </label>
                  </th>
                  <th>
                    <label style="text-align: center;width: 100%;">
                      Send
                      <mat-icon class="explanation"
                                matTooltip="This user is authorized to send incoming faxes from this number within the TeleGo Customer Portal.">
                        info_outline
                      </mat-icon>
                    </label>
                  </th>
                  <th>
                    <label style="text-align: center;width: 100%;">
                      View All<br>Sent Faxes
                      <mat-icon class="explanation"
                                matTooltip="This user can view all sent faxes for this number within the TeleGo Customer Portal.">
                        info_outline
                      </mat-icon>
                    </label>
                  </th>
                  <th>
                    <label style="text-align: center;width: 100%;">
                      Receive Email<br>Notifications
                      <mat-icon class="explanation"
                                matTooltip="This user will receive emails to notify them of any new, unread faxes sent to this number in their TeleGo Customer Portal. These emails will be sent even if the user is logged in.">
                        info_outline
                      </mat-icon>
                    </label>
                  </th>
                  <th>
                    <label style="text-align: center;width: 100%;">
                      Receive Fax To Email
                      <mat-icon class="explanation"
                                matTooltip="This user will receive emails with fax attachment.">
                        info_outline
                      </mat-icon>
                    </label>
                  </th>
                  <th>
                    <label style="text-align: center;width: 100%;">
                      Send Email to Fax
                      <mat-icon class="explanation"
                                matTooltip="This user will be able to send fax from his email.">
                        info_outline
                      </mat-icon>
                    </label>
                  </th>
                  <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody formArrayName="faxDomains">
                <tr *ngFor="let item of faxDomains.controls; let i=index" [formGroupName]="i"
                    style="vertical-align: top;">
                  <td>
                    <app-mat-simple-select [formControl]="getFormControl('domain', item)" [hideLabel]="true"
                                           name="domain" [inlineLabel]="true" [selectItems]="customerFaxDomains"
                                           [hideRequiredMarker]="true"
                                           [submitted]="submitted"></app-mat-simple-select>
                  </td>
                  <td class="center-cell">
                    <app-mat-checkbox-input [formControl]="getFormControl('allowReceive', item)" name="allowReceive"
                                            [submitted]="submitted"></app-mat-checkbox-input>
                  </td>
                  <td class="center-cell">
                    <app-mat-checkbox-input [formControl]="getFormControl('allowSend', item)" name="allowSend"
                                            [submitted]="submitted"></app-mat-checkbox-input>
                  </td>
                  <td class="center-cell">
                    <app-mat-checkbox-input [formControl]="getFormControl('viewAllSend', item)" name="viewAllSend"
                                            [submitted]="submitted"></app-mat-checkbox-input>
                  </td>
                  <td class="center-cell">
                    <app-mat-checkbox-input [formControl]="getFormControl('receiveEmail', item)" name="receiveEmail"
                                            [submitted]="submitted"></app-mat-checkbox-input>
                  </td>
                  <td class="center-cell">
                    <app-mat-checkbox-input [formControl]="getFormControl('faxToMailReceive', item)"
                                            name="faxToMailReceive"
                                            [submitted]="submitted"></app-mat-checkbox-input>
                  </td>
                  <td class="center-cell">
                    <app-mat-checkbox-input [formControl]="getFormControl('faxToMailSend', item)" name="faxToMailSend"
                                            [submitted]="submitted"></app-mat-checkbox-input>
                  </td>

                  <td>
                    <button mat-icon-button color="warn" (click)="removeFaxDomain(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <button type="button" mat-stroked-button (click)="addFaxDomain()">
                <mat-icon>add</mat-icon>
                Add Domain
              </button>
            </div>
          </mat-card-content>
        </mat-card>
      </form>
    </div>
  </div>
</div>
<div class="has-edit-action-bar">&nbsp;</div>
<div class="edit-action-bar" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <button mat-raised-button type="button" color="primary" matTooltip="Save changes"
          (click)="onSubmit()" [disabled]="submitted" [promiseBtn]="buttonSubmitPromise"
          *ngIf="hasEditAccess">Save
  </button>
</div>
